import { render, staticRenderFns } from "./DesignSettings.vue?vue&type=template&id=093619f0&scoped=true&"
import script from "./DesignSettings.vue?vue&type=script&lang=js&"
export * from "./DesignSettings.vue?vue&type=script&lang=js&"
import style0 from "./DesignSettings.vue?vue&type=style&index=0&id=093619f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "093619f0",
  null
  
)

export default component.exports